import { generateArticleListSchema } from "./generators";
import { JsonLdScript } from "./JsonLdScript";

export interface ArticleItem {
  name: string;
  url: string;
  datePublished?: string;
  description?: string;
}

export interface ArticleListSchemaProps {
  items: ArticleItem[];
}

export function ArticleListSchema({ items }: ArticleListSchemaProps) {
  if (items.length === 0) {
    return null;
  }

  const schema = generateArticleListSchema({ items });

  return <JsonLdScript schema={schema} />;
}
